module.exports = __webpack_public_path__ + "static/img/S50.7ac1240.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/S50.png
// module id = nLkI
// module chunks = 0